module.exports = __webpack_public_path__ + "static/media/m1tj44.db7b4289.png";